/* eslint-disable no-use-before-define */
import React from 'react'


export const DealerToDealerIcon = ({fill = '#EF6F06', width, height, x, y, cx, cy, r, }) => (
    <React.Fragment>
    <svg viewBox="0 0 10 10" {...{width, height, x, y, cx, cy, r,}}>
        <rect x="0" y="0" width="10" height="10" fill={fill} />
    </svg>
    </React.Fragment>
)

export const CustomerSellIcon = ({fill = '#006CB6', width, height, x, y, cx, cy, r, }) => (
    <React.Fragment>
    <svg viewBox="-1 -1 12 12" {...{width, height, x, y, cx, cy, r,}}>
        <polygon points="5,-1 11,11 -1,11" fill={fill} />
    </svg>
    </React.Fragment>
)   

export const CustomerBuyIcon = ({fill = '#8B06B9', width, height, x, y, cx, cy, r, }) => {
    return (
    <React.Fragment>
    <svg viewBox="0 0 10 10" {...{width, height, x, y, cx, cy, r}}>
        <circle cx="5" cy="5" r="5" fill={fill} />
    </svg>
    </React.Fragment>
)}

export const getIcon = (label) => {
    if (!label) return null
    const l = label.toLowerCase()
    const props = {width: 10, height: 10}
    if (l.includes('dealer to dealer')) return <DealerToDealerIcon {...props} />
    if (l.includes('customer sell')) return <CustomerSellIcon {...props} />
    if (l.includes('customer buy')) return <CustomerBuyIcon {...props} />
    return null
}


// WEBPACK FOOTER //
// ./src/trade-history/history/chart-shapes.js